import { AfterViewChecked, ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AppLanguages, ContractError } from './core/models/models';
import { environment } from 'src/environments/environment';
import { AuthFactoryService } from './auth/authFactory.service';
import { ENVIRONMENT } from './core/enums/enums';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent
} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements AfterViewChecked {
  title = 'teleperformance-travel';
  loading = true;
  error$: Observable<ContractError>;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private authFactoryService: AuthFactoryService
  ) {
    this.setOperationLang();
  }

  setOperationLang() {
    let lang = AppLanguages.english;

    if (environment.name !== ENVIRONMENT.develop) {
      lang = AppLanguages.spanish;
    }

    this.translate.setDefaultLang(lang);
    this.authFactoryService.dispatchSaveLang(lang);
  }

  ngAfterViewChecked() {
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
    this.cdRef.detectChanges();
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      this.loading = false;
    }
  }
}
